<template>
  <w-sliding-popup ref="slidingPopup" title="스크립트 실행" top="50px" width="650px" @close="close">
    <div slot="content" v-loading="loading">
      <el-steps :active="activeStep" finish-status="success">
        <el-step title="정보 확인"></el-step>
        <el-step title="대상 장비 선택"></el-step>
        <el-step title="실행 결과 확인"></el-step>
      </el-steps>
      <!-- 1. 정보 확인 -->
      <div v-show="activeStep === 1">
        <el-row class="mr-b25 list form-list" :gutter="10">
          <el-col :span="12">
            <el-form label-position="left">
              <el-form-item label="정책명" label-width="90px"><span>{{ ruleScriptDetailInfo.policyDescr }}</span></el-form-item>
              <el-form-item label="룰이름" label-width="90px"><span>{{ ruleScriptDetailInfo.ruleName }}</span></el-form-item>
              <el-form-item label="수행일시" label-width="90px"><span>{{ convertDatetime(ruleScriptDetailInfo.checkDatetime) }}</span></el-form-item>
            </el-form>
          </el-col>
          <el-col :span="12">
            <el-form label-position="left">
              <el-form-item label="등급" label-width="90px"><span>{{ ruleScriptDetailInfo.severityName }}</span></el-form-item>
              <el-form-item label="권장스크립트" label-width="90px"><span>{{ ruleScriptDetailInfo.templateName }}</span></el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row class="mr-b25">
          <div class="title-bar title-h4">룰 상세내용</div>
          <el-input readonly resize="none" type="textarea" :rows="5" :value="ruleScriptDetailInfo.ruleDescr" class="readonly-input-class"></el-input>
        </el-row>
        <el-row class="title-bar">
          <div class="title-h4">권장 스크립트</div>
          <span class="mr-l4 info-text" style="font-size:13px;">스크립트 설명: 배너를 생성합니다.</span>
        </el-row>
        <el-input readonly resize="none" type="textarea" :rows="10" :value="ruleScriptDetailInfo.script" class="readonly-input-class"></el-input>
      </div>
      <!-- 2. 대상 장비 선택 -->
      <div v-show="activeStep === 2">
        <el-row class="mr-b25">
          <div class="title-bar title-h4">대상 장비</div>
          <div class="list form-list">
            <el-form label-position="left">
              <el-form-item label="장비명" label-width="100px"><span>{{ popupParams.objName }}</span></el-form-item>
              <el-form-item label="IP 주소" label-width="100px"><span>{{ popupParams.ipaddress }}</span></el-form-item>
            </el-form>
          </div>
        </el-row>
        <el-row>
          <div class="title-bar title-h4">대상 장비 추가 선택</div>
          <el-table-wrapper :data="nonComplianceDeviceList" :columns="nonComplianceDeviceTableColumns" :column-default="columnDefault" :show-custom-header="false" :show-search-tool="false"
            :pagination="false" @selection-change="onSelectionChange"></el-table-wrapper>
        </el-row>
      </div>
      <!-- 3. 실행 결과 확인 -->
      <div v-show="activeStep === 3">
        <el-row class="mr-b25">
          <div class="title-bar title-h4">실행결과</div>
          <el-table-wrapper :data="scriptExecuteResultList" :columns="executeResultTableColumns" :column-default="columnDefault" :show-custom-header="false"
           :pagination="false" @row-click="onRowClick">
            <template slot-scope="scope" slot="slot">
              <span v-if="scope.column.property === 'jobStatus' && scope.row.jobStatus === '0'" style="color: red">실패</span>
              <span v-else-if="scope.column.property === 'jobStatus' && scope.row.jobStatus === '1'" style="color: blue">성공</span>
              <div v-else-if="scope.column.property === 'jobResult'">
                <span v-if="!scope.row.jobResult" class="link">스크립트 실행을 실패하였습니다.</span>
                <span v-else class="link">{{ scope.row.jobResult }}</span>
              </div>
            </template>
          </el-table-wrapper>
        </el-row>
        <el-row>
          <div class="title-bar title-h4">결과 메시지</div>
          <el-input readonly resize="none" type="textarea" :rows="12" :value="selectedJobResult" class="readonly-input-class"></el-input>
        </el-row>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button v-show="activeStep === 1" size="large" type="solid" @click="changeNextStep">다음단계</el-button>
      <el-button v-show="activeStep === 2" size="large" type="solid" @click="executeScript">스크립트 실행</el-button>
      <el-button size="large" @click="close()">{{ activeStep === 3 && loading === false ? '확인' : '취소' }}</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import isNil from 'lodash/isNil';
import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
import forEach from 'lodash/forEach';
import { columnDefault } from '@/constants/table';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import msgUtil from '@/utils/message';
import netdeviceInfoAPI from '@/api/config/netdevice/netdevice-info';

const RULE_SCRIPT_TASK_PREFIX = 'rule-script-';
export default {
  name: 'WExecuteRuleScriptPopup',
  props: {
    popupParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      popupVisible: false,
      activeStep: 1,
      loading: false,
      columnDefault,
      selectedDeviceList: [],
      selectedJobResult: '',
      executeResultJobSeq: null,
      getProgressRateInterval: null, // clearInterval을 위해 전역선언
      ruleScriptDetailInfo: {},
      nonComplianceDeviceList: [],
      scriptExecuteResultList: [],
      nonComplianceDeviceTableColumns: [{ type: 'selection' }, { prop: 'objName', label: '장비명', sortable: true }, { prop: 'ipaddress', label: 'IP 주소', sortable: true }],
      executeResultTableColumns: [
        { prop: 'jobStatus', label: '결과', scopedSlot: 'slot', width: '80', sortable: false },
        { prop: 'objName', label: '장비명', width: '200', sortable: true },
        { prop: 'jobResult', label: '결과 메시지', scopedSlot: 'slot', sortable: true },
      ],
    };
  },
  beforeDestroy() {
    this.removeScriptTask();
  },
  methods: {
    open() {
      // this.popupVisible = true;
      this.$emit('open');
      this.$refs.slidingPopup.visible = true;
      this.activeStep = 1;
      this.loadData();
    },
    close() {
      // this.popupVisible = false;
      this.removeScriptTask();
      this.$emit('close');
      this.$refs.slidingPopup.visible = false;
    },
    /**
     * 스크립트 수행팝업 데이터 로드
     * @author jeee12
     */
    loadData() {
      if (this.activeStep === 1) {
        this.loadScriptDetailInfoData();
      } else if (this.activeStep === 2) {
        this.loadNonComplianceDeviceData();
      } else if (this.activeStep === 3) {
        this.loadExecuteScriptResultData();
      }
    },
    /**
     * 룰 상세정보 데이터 로드
     * @author jeee12
     */
    loadScriptDetailInfoData() {
      this.$nextTick(() => {
        netdeviceInfoAPI
          .getRuleScriptDetailInfo({
            policyId: this.popupParams.policyId,
            ruleId: this.popupParams.ruleId,
          })
          .then((response) => {
            if (response.data.success) {
              const result = response.data.data[0];
              this.ruleScriptDetailInfo = result;
            }
          });
      });
    },
    /**
     * 미준수 장비 목록 데이터 로드
     * @author jeee12
     */
    loadNonComplianceDeviceData() {
      this.$nextTick(() => {
        netdeviceInfoAPI
          .getNonComplianceDeviceList({
            policyId: this.popupParams.policyId,
            ruleId: this.popupParams.ruleId,
            exceptObjId: this.popupParams.objId,
          })
          .then((response) => {
            if (response.data.success) {
              this.nonComplianceDeviceList = response.data.data;
            }
          });
      });
    },
    /**
     * 스크립트 실행 결과 데이터 로드
     * @author jeee12
     */
    loadExecuteScriptResultData() {
      this.$nextTick(() => {
        netdeviceInfoAPI
          .getExecuteScriptResult({
            jobSeq: this.executeResultJobSeq,
          })
          .then((response) => {
            if (response.data.success) {
              // 스크립트 실행 완료 후 결과 리스트 호출되면 load 해제
              this.loading = false;
              this.$message({
                type: 'success',
                message: '스크립트 실행을 완료하였습니다.',
              });
              this.scriptExecuteResultList = response.data.data;
            }
          })
          .catch(() => {
            this.$message({
              type: 'error',
              message: '결과 메시지 확인을 실패하였습니다.',
            });
          });
      });
    },
    /**
     * 폼 날짜 포맷 설정
     * @author jeee12
     */
    convertDatetime(datetimeValue) {
      if (isNil(datetimeValue)) {
        return EMPTY_TEXT;
      }
      return getDateToString(datetimeValue);
    },
    /**
     * 테이블 selection change 함수, 스크립트 실행할 추가 대상 장비 선택
     * @author jeee12
     * @param  {[type]} selection 선택한 장비들
     */
    onSelectionChange(selection) {
      this.selectedDeviceList = selection;
    },
    /**
     * 테이블 row click 함수, 스크립트 실행 결과 메세지 조회
     * @author jeee12
     * @param  {[type]} row 선택한 row
     */
    onRowClick(row) {
      if (!row.jobResult) {
        this.selectedJobResult = '스크립트 실행을 실패하였습니다.';
      } else {
        this.selectedJobResult = row.convertedJobResult;
      }
    },
    /**
     * 테이블 데이터 빈 값 확인
     * @author jeee12
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 스크립트 실행 팝업 > 다음 단계로 이동
     * @author jeee12
     */
    changeNextStep() {
      this.activeStep += 1;
      this.showSearchTool = false;
      this.loadData();
    },
    /**
     * 스크립트 실행 click
     * @author jeee12
     */
    executeScript() {
      const action = '권장 스크립트를 수행';
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        this.loading = true;
        const params = { script: this.ruleScriptDetailInfo.script, objIds: [this.popupParams.objId] };
        this.selectedDeviceList.forEach((obj) => {
          params.objIds.push(obj.objId);
        });

        netdeviceInfoAPI.executeScript(params).then((result) => {
          if (result.data.success === true) {
            this.executeResultJobSeq = result.data.data;
            const scriptTask = `${RULE_SCRIPT_TASK_PREFIX}${this.ruleScriptDetailInfo.scriptName}_${params.objId}-task`;
            this.$taskManager.createTask(scriptTask, 1, () => {
              netdeviceInfoAPI
                .getExecuteProgressRate({
                  jobSeq: this.executeResultJobSeq,
                })
                .then((progressResult) => {
                  const progressRate = progressResult.data.data;
                  if (progressRate === 1) {
                    this.changeNextStep();
                    this.$taskManager.removeTask(scriptTask);
                  }
                })
                .catch(() => {
                  this.loading = false;
                  this.$message(msgUtil.getCustomResultMsgData('스크립트 수행 진행 완료 여부를 확인하지 못하였습니다.', false));
                });
            }, false, 180, () => {
              this.loading = false;
              this.$message(msgUtil.getCustomResultMsgData('시간 초과로 스크립트 수행 진행 완료 여부를 확인하지 못하였습니다.', false));
            });
            this.$taskManager.startTask(scriptTask);
          }
        });
      }).catch(() => {});
    },
    /**
     * 현재 관리 중인 정책 룰 스크립트 task를 삭제한다.
     * @author Ju
     * @return {[type]} [description]
     */
    removeScriptTask() {
      const taskNames = this.$taskManager.getTaskNames();
      if (!isEmpty(taskNames)) {
        const scriptTaskNames = filter(taskNames, (name) => name.indexOf(RULE_SCRIPT_TASK_PREFIX) >= 0);
        if (!isEmpty(scriptTaskNames)) {
          forEach(scriptTaskNames, (taskName) => {
            this.$taskManager.removeTask(taskName);
          });
        }
      }
    },
  },
};
</script>

<style>
.readonly-input-class .el-textarea__inner {
  background: #f0f2f4;
}
</style>



// WEBPACK FOOTER //
// src/views/config/group/netdevice/components/popup/ExecuteRuleScriptPopup.vue